import baseStyled, { useTheme } from 'styled-components';

// Re-exporting styled allows consumers to gain full TypeScript typing
// when working with Trellis tokens. Otherwise it has to be manually coerced
// in every single implementation, and that's a lot of work.
export const styledWithTrellis = baseStyled;
export function useTrellisTheme() {
  return useTheme();
}